export default __webpack_public_path__ + "static/media/yoga.1b2c231e.svg";